module.exports = __webpack_public_path__ + "img/texiao-_0000s_0010_11.be8365ff.png";